import { useState } from "react";
import { Button } from "@/components/ui/button";

export type CopyResult = "copied" | "failed";
type ClipboardLike = Pick<Clipboard, "writeText"> | undefined;

/** Copies the command; a missing or refusing clipboard (permissions, insecure context) resolves to "failed", never throws. */
export async function copyCommand(command: string, clipboard: ClipboardLike = globalThis.navigator?.clipboard): Promise<CopyResult> {
  if (!clipboard) return "failed";
  try {
    await clipboard.writeText(command);
    return "copied";
  } catch {
    return "failed";
  }
}

export const COPY_FAILED = "Copy failed. Select the text and copy it.";

export function CliTwin({ command, initial = null }: { command: string; initial?: CopyResult | null }) {
  const [result, setResult] = useState<CopyResult | null>(initial);
  return <div className="flex flex-wrap items-center gap-2 border-t border-ks-grey-4 pt-3 text-sm text-ks-grey-1">
    <span>Same in terminal: <code className="select-all text-ks-ink">{command}</code></span>
    <Button type="button" variant="outline" size="sm" data-nonmutating onClick={() => void copyCommand(command).then(setResult)}>{result === "copied" ? "Copied" : "Copy"}</Button>
    {result === "failed" && <span role="status" className="text-ks-ink">{COPY_FAILED}</span>}
  </div>;
}
